import { render, staticRenderFns } from "./WuuHuu.vue?vue&type=template&id=6157ba02&scoped=true&"
import script from "./WuuHuu.vue?vue&type=script&lang=ts&"
export * from "./WuuHuu.vue?vue&type=script&lang=ts&"
import style0 from "./WuuHuu.vue?vue&type=style&index=0&id=6157ba02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157ba02",
  null
  
)

export default component.exports